import React from 'react';
import styled from 'styled-components';

const StyledAboutSection = styled.section`
  padding: 100px 150px;
  max-width: 900px;
  margin: 0 auto;

  h2 {
    display: flex;
    align-items: center;
    position: relative;
    margin: 10px 0 40px;
    width: 100%;
    font-size: clamp(26px, 5vw, 32px);
    white-space: nowrap;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 0;
      width: 300px;
      height: 1px;
      margin-left: 20px;
      background-color: var(--lightest-navy);
    }
  }

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 50px;
  }
`;

const StyledText = styled.div`
  p {
    margin: 0 0 15px;
  }

  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    padding: 0;
    margin: 20px 0 0 0;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: 13px;

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--cyan);
        font-size: 14px;
        line-height: 12px;
      }
    }
  }
`;

const skills = ['Python', 'TensorFlow', 'PyTorch', 'React', 'Node.js', 'AWS'];

const About = () => (
  <StyledAboutSection id="about">
    <h2>About Us</h2>
    <div className="inner">
      <StyledText>
        <div>
                  <p>
                    Hello! We're JDLumen.ai, a passionate team of AI specialists, software engineers, and designers committed to transforming industries through intelligent technology. We thrive on solving complex challenges and turning innovative ideas into powerful, scalable, and user-friendly AI applications.
                  </p>
                  <p>
                    Working on digital solutions since 2023, we’ve earned the name of a trusted IT software development company ready to build anything from an ERP to a retail app. The clients come to us again and again because they see the code quality and security.
                  </p>
                  <p>
                    Our mission is to empower businesses by integrating cutting-edge AI solutions that drive efficiency, unlock new opportunities, and create lasting value.
                  </p>
                  <p>Here are a few technologies we’ve been working with recently:</p>
                </div>
        <ul className="skills-list">
          {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
        </ul>
      </StyledText>
      <div>
        {/* Placeholder for an image or illustration */}
      </div>
    </div>
          <StyledWhyChooseUsSection>
            <h3>Why Choose Us?</h3>
            <ul>
              <li>
                <h4>Expert Team</h4>
                <p>Our team of experienced engineers and designers are dedicated to delivering high-quality solutions.</p>
              </li>
              <li>
                <h4>Innovation</h4>
                <p>We stay at the forefront of technology to bring you the latest and most innovative solutions.</p>
              </li>
              <li>
                <h4>Customer-Centric</h4>
                <p>We work closely with our clients to understand their needs and deliver solutions that exceed expectations.</p>
              </li>
            </ul>
          </StyledWhyChooseUsSection>
        </StyledAboutSection>
    );
    
    const StyledWhyChooseUsSection = styled.div`
      margin-top: 50px;
    
      h3 {
        font-size: 24px;
        color: var(--lightest-slate);
        margin-bottom: 20px;
      }
    
      ul {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 15px;
        list-style: none;
        padding: 0;
      }
    
      li {
        background-color: var(--light-navy);
        padding: 20px;
        border-radius: 4px;
    
        h4 {
          font-size: 18px;
          color: var(--lightest-slate);
          margin-bottom: 10px;
        }
    
        p {
          color: var(--light-slate);
          font-size: 14px;
        }
      }
    `;
    
    export default About;